"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModeConditionSchema = void 0;
const zod_1 = require("zod");
const ModeBoundaryCondition_1 = require("./ModeBoundaryCondition");
const ModeReferenceCondition_1 = require("./ModeReferenceCondition");
const ModeSignalLogicalStateCondition_1 = require("./ModeSignalLogicalStateCondition");
exports.IModeConditionSchema = zod_1.z.union([
    ModeBoundaryCondition_1.ModeBoundaryConditionSchema,
    ModeReferenceCondition_1.ModeReferenceConditionSchema,
    ModeSignalLogicalStateCondition_1.ModeSignalLogicalStateConditionSchema,
]);
//# sourceMappingURL=IModeCondition.js.map